import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import AvailableLendView from "./AvailableLendView";
import {AvailableLendService} from "../../service/ptm/AvailableLendService";

export default class AvailableLendContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);
        this.availableLendService = new AvailableLendService();
        this.getDataAvailableLend = this.getDataAvailableLend.bind(this);

        this.state = {
            dataAvailableLend: this.getDataAvailableLend(''),
            emisoraToSearch: '',
            isLoading: true,
        };

        this.onChangeTextFilter = this.onChangeTextFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.searchEmisora = this.searchEmisora.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que consulta al back para obtener la información de la pantalla
     * Disponible a prestar que se muestra en una tabla.
     * @param emisoraStr Argumento que indica lo que se va a buscar.
     *                  Si viene vacío, se trae toda la información
     * @returns {Promise<void>} Lista que se mostrará en la tabla.
     */
    getDataAvailableLend(emisoraStr) {
        this.loading();
        return this.availableLendService.getDataAvailableLend(emisoraStr)
            .then(dataAvailableLendClient =>
                this.setState({
                    dataAvailableLend: dataAvailableLendClient,
                    isLoading: false,
                }));
    }

    /**
     * Función que se manda a la vista para que se ejecute cuando se da clic en el
     * botón de buscar, ya que busca el texto que se encuentra en la sección
     * de filtros.
     */
    searchEmisora() {
        this.loading();
        this.getDataAvailableLend(this.state.emisoraToSearch)
    }

    /**
     * Función que maneja el cambio de texto en el campo de texto de los filtros
     * Coloca el valor en una variable del estado.
     * @param event Contiene el valor y el objeto modificado.
     */
    onChangeTextFilter(event) {
        const {id, value} = event.target;
        this.setState({[id]: value,})
    }

    /**
     * Función que limpia el valor que se encuentra en la caja de texto de los filtros.
     */
    clearFilters() {
        this.setState({emisoraToSearch: ''})
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataAvailableLend, emisoraToSearch, isLoading} = this.state;

        return <AvailableLendView dataAvailableLend={dataAvailableLend}
                                  isLoading={isLoading}
                                  emisoraToSearch={emisoraToSearch}
                                  messagesGrowl={messagesGrowl}
                                  onChangeTextFilter={this.onChangeTextFilter}
                                  clearFilters={this.clearFilters}
                                  searchEmisora={this.searchEmisora}
                                  searchAll={this.getDataAvailableLend}
        />
    }
};